import { AfterViewChecked, AfterViewInit, Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { VisualizadorService } from '../../../shared/service/visualizador.service';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-mega-menu',
    templateUrl: './mega-menu.component.html',
    styleUrls: ['./mega-menu.component.css'],
    standalone: true,
    imports: [CommonModule]
})
export class MegaMenuComponent implements OnInit {

  public htmlMegaMenu!: SafeHtml;
  public htmlReady: boolean = false;

  constructor(private service: VisualizadorService, private sanitizer: DomSanitizer, private renderer: Renderer2, private el: ElementRef) { }

  ngOnInit(): void {
    this.service.getMegaMenu().subscribe({
      next: (response) => {
        this.htmlMegaMenu = this.sanitizer.bypassSecurityTrustHtml(response);
        this.htmlReady = true;
      },
      error: (error) => {
        console.log("Error inesperado en consultaMegaMenu", error);
      }
    });
  }
}
